import { SimpleIconList } from "@components"
import { CheckCircleIcon } from "@heroicons/react/24/solid"
import PropTypes from "prop-types"

const PresendSummary = ({ counts, filter }) => (
  <SimpleIconList
    iconSize="lg"
    items={[
      { icon: <CheckCircleIcon className="text-green-500" />, caption: filter.description },
      { icon: <CheckCircleIcon className="text-green-500" />, caption: `Total guardians selected from the above category: ${counts.selected} of ${counts.total}` },
      { icon: <CheckCircleIcon className="text-green-500" />, caption: `Total emails to send: ${counts.selected}` },

    ]}
  />    
)

PresendSummary.propTypes = {
  counts: PropTypes.shape({
    deselected: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,

  filter: PropTypes.object.isRequired,
}

export default PresendSummary